import { call, put } from 'redux-saga/effects';
import { OffersAsyncActions } from 'store/actions/offers';
import { apiCall } from 'utils/apiCall';

function* list(action) {
  const {
    ListOffers: {
      Actions: { SUCCESS, FAILURE },
    },
  } = OffersAsyncActions;
  const {
    payload: { id, actions = 'buyer' },
  } = action;

  try {
    const response = yield call(apiCall, `/offers/listings/${id}`, 'get', { actions });
    yield put(SUCCESS(response.data));
  } catch (error) {
    yield put(FAILURE(error));
  }
}

export default list;
